<template>
    <div class="wai">
        <div class="kuai_wai information_wai">
            <div class="touxiang_div" v-show="isOrLoginTs">
                <div class="userNameText">{{ userName.split("")[0] }}</div>
                <div v-html="svgVIP" v-show="showVIP" class="vip_div"></div>
                <div v-html="svgSVIP" v-show="showSVIP" class="svip_div"></div>
            </div>
            <div class="userInformation_div">
                <div v-show="isOrLoginTs" class="loin_inf">
                    <div>欢迎回来</div>
                    <div>{{ userName }}</div>
                </div>
                <div v-show="!isOrLoginTs">
                    <div>点击【注册/登录】</div>
                    <div>开始使用您的战报工具</div>
                </div>
            </div>
            <button class="button_end" v-show="isOrLoginTs" @click="initData">退出登录</button>
            <button class="information_button" v-show="isOrLoginTs" @click="informationButton">个人中心</button>
            <button class="information_button" v-show="!isOrLoginTs" @click="registerJoin">注册/登录</button>
        </div>
        <div class="kuai_wai group_wai">
            <div class="group_join" v-show="!isOrJoinGroupTs">
                <div>加入同盟</div>
                <div style="color: rgb(114 114 114);">创建或加入同盟，与好友分享队伍</div>
                <button :disabled="button_group_none" class="button_group_none" @click="createGroup">创建同盟</button>
                <button :disabled="button_group_none" class="button_group_none" @click="joinGroup">加入同盟</button>
            </div>
            <div class="group_join_ed" v-show="isOrJoinGroupTs">
                <div class="Group_div_t">我的同盟</div>
                <div class="Group_div">
                    <div class="Group_name">{{ GroupName }}</div>
                    <div class="Group_label">{{ Position }}</div>
                </div>
                <div class="group_join_ed_a">
                    <div>邀请码</div>
                    <div class="yqm_div">
                        <div class="Join_code">{{ codeGroup }}</div>
                        <button class="copy-btn" @click="copyGroupCode">复制邀请码</button>
                    </div>
                </div>
                <div class="group_join_ed_a">
                    <div>成员数</div>
                    <div>{{ userNumbers }} 人</div>
                </div>
                <div class="group_join_ed_a">
                    <button class="Group_button" @click="viewMembers">查看成员</button>
                    <button class="Group_button" @click="exitGroup">退出同盟</button>
                </div>
            </div>
        </div>
        <div class="kuai_wai function_wai function_div">
            <div>功能选择</div>
            <div v-show="isOrLoginTs" class="integral_div">积分：{{ integral }}</div>
            <div v-show="!isOrLoginTs">请先注册/登录账号</div>
            <div v-show="isOrLoginTs" class="FS_div">
                <button @click="findTeam" class="FS_button">队伍查询</button>
                <button @click="uploadTeam" class="FS_button">上传队伍</button>
                <button @click="uploadBattleAeport" class="FS_button">上传战报</button>
                <button @click="openVIP" class="FS_button">{{ vipButtonl }}</button>
            </div>
        </div>

        <ModalEI v-if="showModal" v-model:visible="showModal" v-model:titleValue="titleValue"
            @close="showModal = false">
            <loginPageST @save="onEditSave" @close="showModal = false" />
        </ModalEI>

        <ModalEI v-if="showModalGroup" v-model:visible="showModalGroup" v-model:titleValue="titleValueGroup"
            @close="showModalGroup = false">
            <GroupPageST @join="onJoinGroup" @save="onSaveGroup" @close="showModalGroup = false"
                v-model:typePage="typePage" />
        </ModalEI>

        <ModalEI v-if="showModalUp" v-model:visible="showModalUp" v-model:titleValue="titleValueGroup"
            @close="showModalUp = false">
            <UploadReportPageST @save="onUpload" @close="showModalUp = false" />
        </ModalEI>

        <ModalEI v-if="showModalFind" v-model:visible="showModalFind" v-model:titleValue="titleValueGroup"
            @close="showModalFind = false">
            <SearchPage @close="showModalFind = false" @isUpload="searchUp" />
        </ModalEI>

        <ModalEI v-if="showModalPyVIP" v-model:visible="showModalPyVIP" v-model:titleValue="titleValueGroup"
            @close="showModalPyVIP = false">
            <ShopVIP @close="showModalPyVIP = false" />
        </ModalEI>

        <ModalEI v-if="showModalIntroduce" v-model:visible="showModalIntroduce" titleValue="使用介绍"
            @close="showModalIntroduce = false">
            <IntroducePage @close="showModalIntroduce = false" :introduceTextValue="mainIntroduceTexts" />
        </ModalEI>

        <ModalEI v-if="showModalGroupIntroduce" v-model:visible="showModalGroupIntroduce"
            v-model:titleValue="titleValueGroup" @close="showModalGroupIntroduce = false">
            <GroupIntroduce @close="showModalGroupIntroduce = false" />
        </ModalEI>

        <ModalEI v-if="showModalinformation" v-model:visible="showModalinformation" v-model:titleValue="titleValueGroup"
            @close="showModalinformation = false">
            <UserIntroduce @close="showModalinformation = false" />
        </ModalEI>
    </div>
</template>

<script>
import ClipboardJS from 'clipboard';
import request from '@/utils/request' // 就写这一行
import { mainIntroduceText } from './mainSTconfig';
import { svgRead } from '@/svgIcon/main';

export default {
    name: 'ShuaituMorPPage',
    data() {
        return {
            isOrLoginTs: false,
            isOrJoinGroupTs: false,
            currentData: {},
            isViewMode: false,
            showModal: false,
            showModalGroup: false,
            titleValue: "",
            button_group_none: false,
            userName: "用户名",
            titleValueGroup: "",
            codeGroup: "",
            GroupName: "",
            typePage: "",
            Position: "",
            userNumbers: 0,
            showModalUp: false,
            showModalFind: false,
            showModalPyVIP: false,
            integral: 0,
            showModalIntroduce: false,
            mainIntroduceTexts: mainIntroduceText,
            showModalGroupIntroduce: false,
            showModalinformation: false,
            showVIP: false,
            showSVIP: false,
            svgVIP: svgRead('vip-a', null, 30, 30),
            svgSVIP: svgRead('svip-a', null, 60, 60),
            clipboard: null,
            vipButtonl: '开通VIP'
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('token');
            this.$router.push({ name: 'LoginPage' });
        },
        onEditSave(formData) {
            localStorage.setItem('userData', JSON.stringify(formData));
            this.HuoQuShuJu();
        },
        onSaveGroup(formData) {
            var storedData = JSON.parse(localStorage.getItem('userData'));
            if (storedData.user.user.ID != formData.userID) {
                this.$messageX.xiaoxiti("e", "数据错误！请重新登录或联系管理员！");
                this.initData();
                return;
            }
            storedData.user.user.Department = formData.Department;
            storedData.user.user.DepartmentID = formData.DepartmentID;
            storedData.user.user.Position = formData.Position;
            storedData.user.user.CodeGroup = formData.CodeGroup;
            storedData.user.user.UserNumber = formData.UserNumber;

            localStorage.setItem('userData', JSON.stringify(storedData));

            this.HuoQuShuJu();
        },
        onUpload(formData) {
            var storedData = JSON.parse(localStorage.getItem('userData'));
            localStorage.removeItem('userData');
            storedData.user.user.Integral = formData.response.add_integral + this.integral;
            localStorage.setItem('userData', JSON.stringify(storedData));
            this.integral = formData.response.add_integral + this.integral;
            this.HuoQuShuJu();

        },
        huoQuLocalStorage() {
            if (localStorage.userData) {
                this.HuoQuShuJu();

            } else {
                this.initData();
            }
        },
        initData() {
            this.button_group_none = true;
            this.showModal = false;
            this.showModalGroup = false;
            this.isViewMode = false;
            this.isOrLoginTs = false;
            this.isOrJoinGroupTs = false;
            this.currentData = {};
            this.titleValueGroup = "";
            this.titleValue = "";
            this.GroupName = "";
            this.codeGroup = "";
            this.typePage = "";
            this.Position = "";
            this.userNumbers = 0;
            this.showModalGroupIntroduce = false;
            this.showModalIntroduce = true;
            localStorage.clear();
            document.getElementsByClassName("userInformation_div")[0].style.width = "calc(100% - 40vw)";
            this.showVIP = false;
            this.showSVIP = false;
            this.vipButtonl = '开通VIP';
            if (this.clipboard) {
                this.clipboard.destroy(); // 销毁实例，移除事件监听
                this.clipboard = null;    // 释放引用
            }
        },
        createGroup() {
            this.titleValueGroup = "创建同盟";
            this.typePage = "creatGroup";
            this.showModalGroup = true;

        },
        joinGroup() {
            this.titleValueGroup = "同盟申请";
            this.typePage = "joinGroup";
            this.showModalGroup = true;

        },
        onJoinGroup(formData) {
            var storedData = JSON.parse(localStorage.getItem('userData'));
            if (storedData.user.user.ID != formData.userID) {
                this.$messageX.xiaoxiti("e", "数据错误！请重新登录或联系管理员！");
                this.initData();
                return;
            }
            storedData.user.user.Department = formData.Department;
            storedData.user.user.DepartmentID = formData.DepartmentID;
            storedData.user.user.Position = formData.Position;
            storedData.user.user.CodeGroup = formData.CodeGroup;
            storedData.user.user.UserNumber = formData.UserNumber;
            localStorage.setItem('userData', JSON.stringify(storedData));
            this.HuoQuShuJu();
        },
        informationButton() {
            console.log("点击个人中心");
            this.showModalinformation = true;
            this.titleValueGroup = "个人中心";
        },
        registerJoin() {
            this.showModal = true;
            this.titleValue = "注册/登录";
        },
        viewMembers() {
            this.showModalGroupIntroduce = true;
            this.titleValueGroup = "查看成员";
        },
        exitGroup() {
            this.$messageX.tipWin({ "magess": "确定退出同盟？", "magess_title": "提示" }, this.exitGroupf, this.emptyFunction);
        },
        async exitGroupf() {
            var storedData = JSON.parse(localStorage.getItem('userData'));
            try {
                // 自动带 Token，自动处理错误
                const res = await request.post('/ExitGroup', {
                    DepartmentID: storedData.user.user.DepartmentID
                });

                // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
                this.$messageX.xiaoxiti("c", res.message);
                storedData.user.user.Department = res.response.Department;
                storedData.user.user.DepartmentID = res.response.DepartmentID;
                storedData.user.user.Position = res.response.Position;
                storedData.user.user.CodeGroup = res.response.CodeGroup;
                storedData.user.user.UserNumber = res.response.UserNumber;
                storedData.user.user.DepartmentName = res.response.Department;

                localStorage.setItem('userData', JSON.stringify(storedData));

                this.HuoQuShuJu();
            } catch (err) {
                // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                } else {
                    this.initData();
                    this.$messageX.xiaoxiti("e", err.message);
                }
            }
        },
        findTeam() {
            // console.log("点击队伍查询");
            this.showModalFind = true;
            this.titleValueGroup = "队伍查询";
        },
        uploadTeam() {
            // console.log("点击上传队伍");
            this.showModalUp = true;
            this.titleValueGroup = "上传队伍";
        },
        emptyFunction() {

        },
        openVIP() {
            console.log("点击开通VIP");
            this.showModalPyVIP = true;
            this.titleValueGroup = "购买VIP";
        },
        async HuoQuShuJu() {
            var storedData = JSON.parse(localStorage.getItem('userData'));
            try {
                const response = await fetch('//www.aboluo.site/api/VerifyTK', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ "token": storedData.user.token })
                });

                const data = await response.json();

                if (data.success) {
                    // this.$messageX.xiaoxiti("c", "欢迎回来！");
                    this.isOrLoginTs = true;
                    this.userName = storedData.user.user.Accounts;
                    this.button_group_none = false;
                    if (storedData.user.user.DepartmentID != null && storedData.user.user.DepartmentID != "") {
                        if (storedData.user.user.CodeGroup != null && storedData.user.user.CodeGroup != "") {
                            this.isOrJoinGroupTs = true;
                            document.getElementsByClassName("userInformation_div")[0].style.width = "calc(100% - 60vw)";
                            this.codeGroup = storedData.user.user.CodeGroup;
                            this.GroupName = storedData.user.user.Department;
                            this.userNumbers = storedData.user.user.UserNumber;
                            this.Position = storedData.user.user.Position;
                            this.integral = storedData.user.user.Integral;
                            if (storedData.user.user.IsVIP == 1) {
                                this.showVIP = true;
                                this.showSVIP = false;
                                this.vipButtonl = '续费vip';
                            } else if (storedData.user.user.IsVIP == 2) {
                                this.showVIP = false;
                                this.showSVIP = true;
                                this.vipButtonl = '续费svip';
                            }
                        } else {
                            this.isOrJoinGroupTs = false;
                            this.$messageX.xiaoxiti("e", "数据错误！请联系管理员！");
                        }
                    } else {
                        this.isOrJoinGroupTs = false;
                    }
                } else {
                    this.$messageX.xiaoxiti("e", data.message || data.message);
                    this.initData();
                }
            } catch (error) {
                this.initData();
                console.error('VerifyTK error:', error);
                this.$messageX.xiaoxiti("e", "网络错误，请检查连接");
            }
        },
        initClipboard() {
            this.clipboard = new ClipboardJS('.copy-btn', {
                text: () => this.codeGroup // 返回要复制的文本
            });

            this.clipboard.on('success', (e) => {
                this.$message.success('邀请码已复制到剪贴板！');
                e.clearSelection();
            });

            this.clipboard.on('error', (e) => {
                console.error('复制失败:', e);
                this.$message.error('复制失败，请手动复制');
            });
        },
        uploadBattleAeport() {
            confirm("敬请期待");
        },
        async refresh() {
            try {
                // 自动带 Token，自动处理错误
                const res = await request.post('/AgainRefresh', {
                })

                // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
                let storedData = JSON.parse(localStorage.getItem('userData'));
                let re = res.response.user;
                for (let item of Object.keys(re)) {
                    if (storedData.user.user[item] != re[item]) {
                        storedData.user.user[item] = re[item];
                    }
                }
                localStorage.setItem('userData', JSON.stringify(storedData));

                this.HuoQuShuJu();
            } catch (err) {
                // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                } else {
                    this.initData();
                    this.$messageX.xiaoxiti("e", err.message);
                }
            }
        },
        searchUp() {
            this.HuoQuShuJu();
        }
    },
    mounted() {
        this.huoQuLocalStorage();
        this.initClipboard();
        this.$socket.on('comprehensive_news', (data) => {
            if (this.$socket.diversion(data).success) {
                if (data.notify) {
                    if (data.notifyType == 'message') {
                        this.$messageX.xiaoxiti("i", data.message);
                    } else if (data.notifyType == 'confirm') {
                        confirm(data.message);
                    } else {
                        console.error('回传数据包错误！');
                    }
                }
                this.refresh();
            }
        });

    },
    beforeUnmount() {
        this.$socket.off('report_uploaded');
        this.$socket.off('information_changed');
        if (this.clipboard) {
            this.clipboard.destroy(); // 销毁实例，移除事件监听
            this.clipboard = null;    // 释放引用
        }
    }
};
</script>

<style scoped>
.wai {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    padding: 2vh 2vw 2vh 2vw;
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
}

.kuai_wai {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    padding: 2vh 2vw 2vh 2vw;
    width: calc(100% - 4vw);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 12px;
    box-shadow: 3px 4px 8px 1px rgb(135 126 126);
    margin-bottom: 15px;
    padding: 15px;
}

.group_wai {
    height: 30vh;
}

.information_wai {
    height: 9vh;
}

.function_wai {
    height: calc(100% - 39vh);
}

.touxiang_div {
    border-radius: 100%;
    background-color: rgb(0, 149, 248);
    height: 50px;
    width: 50px;
    margin-right: 10px;
    border: 2px solid #0150d8;
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    position: relative;
}

.userNameText {
    color: rgba(255, 255, 255, 1);
}

.information_button {
    height: 3vh;
    width: 20vw;
}

.button_end {
    height: 3vh;
    width: 20vw;
    border: 2px solid #ff0000;
    background-color: #ff0000;
    color: #fff;
    margin-right: 5px;
}

button {
    border-radius: 15px;
    color: rgba(255, 255, 255, 1);
    border: 0px solid #000;
    transform: translateY(-3px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, .15);
    background-color: #4a76da;
}

.userInformation_div {
    height: 100%;
    width: calc(100% - 40vw);
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: flex-start;
    justify-content: center;
    align-items: center;
}

.information_text_div {
    height: 100%;
    width: 100%;
    display: flex;
    font-size: 3.5vw;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: flex-start;
    justify-content: center;
    align-items: center;
}

.group_join {
    display: flex;
    font-size: 2vh;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: flex-start;
    justify-content: space-around;
    align-items: flex-start;
    height: 100%;
    width: 100%;
}

.group_join_ed {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-around;
    align-items: stretch;
}

.group_join_ed_a {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    align-content: center;
}

.yqm_div {
    display: flex;
    font-size: 10px;
    justify-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
}

.function_div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.button_group_none {
    width: 100%;
    height: 4vh;
}

div {
    color: rgb(0 0 0);
}

.loin_inf {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: flex-start;
    justify-content: center;
    align-items: flex-start;
}

.FS_div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: calc(100% - 5vw);
}

.FS_button {
    width: 100%;
    height: 4vh;
}

.Group_div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
}

.Group_div_t {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
}

.Group_name {
    font-size: 4;
}

.Group_label {
    border-radius: 10%;
    background-color: #0fd681;
    width: 20vw;
    border: 2px solid #ffffff;
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.Join_code {
    margin-right: 10px;
}

.Group_button {
    width: 40%;
    height: 3vh;
}

.integral_div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
}

.vip_div {
    position: absolute;
    right: -5px;
    bottom: -20px;
}

.svip_div {
    position: absolute;
    right: -5px;
    bottom: -32px;
}
</style>
